import { type MinistryTypeKey } from '@/shared/types/ministry';
import type { GroupTypeKey, Group } from '@/shared/types/group';
import type { GroupPropertiesEntry } from '@/store/groups/types';
import { GroupProperties } from '@/store/groups/types';

export function makeGroup({
  campusId,
  parentId,
  ministry,
  type,
}: {
  campusId: string;
  parentId: string;
  ministry: MinistryTypeKey;
  type: GroupTypeKey;
}): Group {
  return {
    id: '',
    data: {
      type,
      campus_id: campusId,
      ministry,
      oversight_ids: [],
      parent_id: parentId,
      title: '',
      archived: false,
      created_at: '',
      updated_at: '',
    },
  };
}

export function getGroupAlias(
  type: GroupTypeKey,
  key: keyof GroupPropertiesEntry['alias'],
  plural = false,
) {
  const entry = GroupProperties[type];
  if (!entry) {
    debugger;
  }

  const alias = entry.alias[key];

  return alias + (plural ? 's' : '');
}

export function getGroupProperty(
  type: GroupTypeKey,
  key: keyof Omit<GroupPropertiesEntry, 'alias'>,
) {
  const entry = GroupProperties[type];
  if (!entry) {
    debugger;
  }

  return entry[key];
}
